import React from 'react';
import { withTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './YoutubeModal.module.css';
const YoutubeEmbed = ({ videoUrl, t }) => {
  return (
    <div>
      <div styleName="responsive-video">
        <iframe
          title={t('Youtube embed')}
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default withTranslation()(DisplayComponent(YoutubeEmbed));
